import {
  FormControl,
  FormControlProps,
  FormErrorMessage,
  FormErrorMessageProps,
  FormLabel,
  FormLabelProps,
  Text,
} from "@chakra-ui/react";
import React from "react";

export type CustomFormInputProps = {
  id?: string;
  label?: string;
  caption?: string;
  error?: string;
  flex?: string | number;
  isRequired?: boolean;
  formControlProps?: FormControlProps;
  formLabelProps?: FormLabelProps;
  formErrorMessageProps?: FormErrorMessageProps;
  children: React.ReactNode;
};

export const CustomFormInput = ({
  id,
  label,
  caption,
  error,
  flex,
  isRequired = false,
  formControlProps,
  formLabelProps,
  formErrorMessageProps,
  children,
}: CustomFormInputProps) => (
  <FormControl
    flex={flex}
    isInvalid={Boolean(error)}
    isRequired={isRequired}
    height="100%"
    {...formControlProps}
  >
    {label && (
      <FormLabel htmlFor={id} {...formLabelProps}>
        {label}
      </FormLabel>
    )}
    {children}
    {caption && !error && (
      <Text fontSize="sm" mt="8px">
        {caption}
      </Text>
    )}
    {error && (
      <FormErrorMessage {...formErrorMessageProps}>{error}</FormErrorMessage>
    )}
  </FormControl>
);
